import { ENContent } from '../../protocol/EN/privacy';
import { serviceData } from '../../protocol/EN/service';
export default {
	home:{
		title:'hello new world',
		notice:{
			title:'Notice',
			more:'View More'
		},
	},
	tips:{
		down:'Expand',
		up:'Pack Up',
		more:'View More',
		noMore:'No More'
	},
	banner:[
		{
			title:'PCR',
			content:'Product-Category Rules is set of specific rules, requirements and guidelines for developing Type III environmental declarations for one or more product categories.',
			img:require('@/assets/img/index/indexPCR_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		},
		{
			title:'EPD',
			content:'Type III environmental declaration（EPD）is the environmental declaration providing quantified environmental data using predetermined parameters and, where relevant, additional environmental information.',
			img:require('@/assets/img/index/EPD_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		},
		{
			title:'GPI',
			content:'Type III environmental declaration （EPD）programmes are voluntary and have a set of rules guiding their overall administration and operation. These rules, with references to ISO 14025，managed by a programme operator, are referred to as general programme instructions.',
			img:require('@/assets/img/index/GPI_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		},
		{
			title:'LCA',
			content:'Life Cycle Assessment is compilation and evaluation of the inputs, outputs and the potential environmental impacts of a product system throughout its life cycle.',
			img:require('@/assets/img/index/LCA_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		},
		{
			title:'CFP',
			content:'Carbon Footprint Of A Product is sum of GHG emissions and GHG removals in a product system ,expressed as CO2 equivalents and based on a life cycle assessment using the single impact category of climate change.',
			img:require('@/assets/img/index/CFP_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		},	
	],
	nav:[
		{name:'Home',id:'1', path:'/index'},
		{name:'Service Portal',id:'2',  path:'/EPD',
			children:[
				{name:'EPD/CFP',id:'1', path:'/EPD'},
				{name:'PCR',id:'2', path:'/PCR'},
				{name:'LCA',id:'3', path:'/LCA'},
				{name:'GPI',id:'4', path:'/GPI'},
				{name:'My portal',id:'5', path:'/portal'},
			],
		},		
		{name:'News',id:'5', path:'/news'},
		{name:'Resource',id:'6', path:'/resource'},
		{name:'EPD Creation',id:'7', path:'/service'},
		{name:'Contact',id:'8', path:'/connect',
		children:[
			{name:'About',id:'9', path:'/about'},
			{name:'feedback',id:'10', path:'/feedback'}
		]
		},
	],
	usernav:[
		{name:'name 7888',id:'1', path:'/company'},
		{name:'user',id:'2', path:'/user'},
		{name:'Login out',id:'3', path:''},
	],
	footer:{
		call_tips:'联系我们',
		adress:' 中国有色金属行业EPD平台办公室地址：北京市海淀区复兴路乙12号',
		postcode:'邮编：100000',
		call:'客服热线：010-63971471 周一至周五：8:30-17:00',
		ICP_tips:'IP备案号',
		ICP1:'京865636663623',
		ICP2:'京8952236663623'
	},
	login:{
		signIn:'Login',
		register:'Register'
	},
	news:{
		more:'View More',
		banner: [{
			tips:'News',
			title:'',
			content:'',
			img: require('@/assets/img/index/GPI_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		}],
		detail:{
			title:'News Detail',
			Aditor:'Editor:',
			Authors:'Authors:',
			Source:'Source:',
			time:'time:'
		}
	},
	notice:{
		more:'View More',
		banner: [{
			tips:'Notice',
			title:'',
			content:'',
			img: require('@/assets/img/index/GPI_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		}],
		
		detail:{
			title:'Notice Detail',
			Aditor:'Editor:',
			Authors:'Authors:',
			Source:'Source:',
			time:'time:'
		}
	},
	tabCard:[
		{
			title:'PCR Library',
			url:require('@/assets/img/index/seach-pcr_2x.png')
		},
		{
			title:'EPD/CFP Library',
			url:require('@/assets/img/index/seach-epd_2x.png')
		},
		{
			title:'EPD/CFP Portal',
			url:require('@/assets/img/index/seach-crp_2x.png')
		}		
	],
	EPD:{
		banner: [{
			tips:'EPD/CFP',
			title:'EPD',
			content:'Type III environmental declaration（EPD）is the environmental declaration providing quantified environmental data using predetermined parameters and, where relevant, additional environmental information.',
			img:require('@/assets/img/index/EPD_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		},
		{
			tips:'EPD/CFP',
			title:'CFP',
			content:'Carbon Footprint Of A Product is sum of GHG emissions and GHG removals in a product system ,expressed as CO2 equivalents and based on a life cycle assessment using the single impact category of climate change.',
			img:require('@/assets/img/index/CFP_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		}],
		portal:'EPD/CFP Portal',
		seach:'Search for published EPD/CFP'
	},
	PCR:{
		banner: [{
			tips:'PCR/LCA',
			title:'PCR',
			content:'Product-Category Rules is set of specific rules, requirements and guidelines for developing Type III environmental declarations for one or more product categories.',
			img:require('@/assets/img/index/PCR_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		}],
		seach:'Search for published PCR'
	},
	LCA:{
		banner: [{
			tips:'LCA',
			title:'LCA',
			content:'Life Cycle Assessment is compilation and evaluation of the inputs, outputs and the potential environmental impacts of a product system throughout its life cycle.',
			img:require('@/assets/img/index/LCA_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		}],
		seach:'Search for published LCA'
	},
	GPI:{
		banner: [{
			tips:'GPI',
			title:'GPI',
			content:'Type III environmental declaration （EPD）programmes are voluntary and have a set of rules guiding their overall administration and operation. These rules, with references to ISO 14025，managed by a programme operator, are referred to as general programme instructions.',
			img:require('@/assets/img/index/GPI_2x.png'),
			url: require('@/assets/img/index/banner01.png')
		}],
		dwon_CN:'Download (CN)',
		dwon_EN:'Download (EN)',
	},
	resource:{
			banner: [{
				tips:'resource',
				title:'GPI',
				content:'GPI是基于ISO14025 III型环境声明的原则和程序建立的管理规则，是中国有色金属行业EPD平台的运作基础。',
				img: require('@/assets/img/index/GPI_2x.png'),
				url: require('@/assets/img/index/banner01.png')
			}],
			tips_down:'Download Information:',
			dwon_CN:'Download (CN)',
			dwon_EN:'Download (EN)',
			empty:'No Data',
			tabList:[
				{
					id:'1',
					name:'环境绩效声明参数及标准',
					children:[{
							id:'1',
							title:'中国有色金属行业EPD平台环境绩效指标默认清单介绍',
							content:'附件是有色行业EPD平台EPD中环境绩效指标默认清单(以下简称默认清单）以及相应的评价方法介绍。如果某些环境绩效指标在 PCR 开发过程中已经证明是合理的，则 PCR 的要求或建议的环境绩效指标可能与默认清单所列的不一致。默认清单会根据 LCA 方法和标准的发展不断更新，以确保 EPD 的稳定性。在需要更新默认清单的情况下，默认清单的被替代版本至少应有90天的过渡期，在过渡期内，被替代版本与新版本同时有效。',
							img:require('@/assets/img/index/EPD_2x.png'),
							tips:'Download Information:',
							dwon_CN:'Download (CN)',
							dwon_EN:'Download (EN)',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
						{
							id:'2',
							title:'中国有色金属行业EPD 平台和欧标 EN15804 对比分析',
							content:' 附件是中国有色金属行业EPD平台EPD中环境绩效指标默认清单(以下简称默认清单）以及相应的评价方法介绍。如果某些环境绩效指标在 PCR 开发过程中已经证明是合理的，则 PCR 的要求或建议的环境绩效指标可能与默认清单所列的不一致。默认清单会根据 LCA 方法和标准的发展不断更新，以确保 EPD 的稳定性。在需要更新默认清单的情况下，默认清单的被替代版本至少应有90天的过渡期，在过渡期内，被替代版本与新版本同时有效。',
							img:require('@/assets/img/index/EPD_2x.png'),
							tips:'资料下载:',
							dwon_CN:'Download (CN)',
							dwon_EN:'Download (EN)',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
					]
				},
				{
					id:'2',
					name:'文献著作',
					children:[
						{
							id:'1',
							title:'欧盟碳边境调节机制（CBAM）规定及服务介绍',
							content:'碳边境调节机制（CBAM）也被称为碳边境税或碳关税（Carbon Border Tax），是欧盟针对部分进口商品的碳排放量所征收的税费。该机制要求，进口至欧盟或从欧盟出口的高碳产品，缴纳相应额度的税费或退还相应的碳排放配额。 “碳关税”征收的行业覆盖范围钢铁、水泥、铝、化肥、电力及氢，主要针对生产过程中的直接排放和对水泥、电力和化肥这三个大类的间接排放（即在生产过程中使用外购电力、蒸汽、热力或冷力产生的碳排放）以及少量的下游产品。 鉴于中国钢铁行业EPD平台目前已具备为中国钢铁产品提供碳足迹证明的基础条件，且已发布了大量的碳足迹CFP和环境产品声明EPD报告并收集了丰富的钢厂原始数据，平台可为用户提供全链路CBAM服务方案，协助CBAM货物进口商和出口欧盟企业应对CBAM。',
							img:require('@/assets/img/index/GPI_2x.png'),
							tips:'资料下载:',
							dwon_CN:'Download (CN)',
							dwon_EN:'Download (EN)',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
						{
							id:'2',
							title:'双碳时代的企业绿色助手：碳数据与碳服务',
							content:'  附件是有色行业EPD平台EPD中环境绩效指标默认清单(以下简称默认清单）以及相应的评价方法介绍。如果某些环境绩效指标在 PCR 开发过程中已经证明是合理的，则 PCR 的要求或建议的环境绩效指标可能与默认清单所列的不一致。默认清单会根据 LCA 方法和标准的发展不断更新，以确保 EPD 的稳定性。在需要更新默认清单的情况下，默认清单的被替代版本至少应有90天的过渡期，在过渡期内，被替代版本与新版本同时有效。',
							img:require('@/assets/img/index/LCA_2x.png'),
							tips:'资料下载:',
							dwon_CN:'Download (CN)',
							dwon_EN:'Download (EN)',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
					]
				},
				{
					id:'3',
					name:'报告模板',
					children:[
						{
							id:'1',
							title:'中国有色金属行业EPD平台EPD模板',
							content:' 附件是中国有色金属行业EPD平台EPD报告模板，考虑到EPD在某些应用的特殊情况，可对PCR规定的内容和格式提出其他附加要求。一般来说，EPD的内容应：a.符合ISO 14020规定的要求和指南；b.可验证、准确、相关且不误导；c.不包括评级、判断、或直接与其他产品比较；d.EPD的页数应合理，适合于目标受众和用途；e.EPD内容以机读格式发布时，应与所基于的EPD的内容一致。',
							img:require('@/assets/img/index/GPI_2x.png'),
							tips:'资料下载:',
							dwon_CN:'Download (CN)',
							dwon_EN:'Download (EN)',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
						{
							id:'2',
							title:'中国有色金属行业EPD 平台PCR模板',
							content:'附件是中国有色金属行业EPD平台PCR模板，PCR通常包含的内容：封面；介绍；基本信息；PCR的范围；PCR评审和背景信息；目标和范围、生命周期清单和生命周期影响评价；基于PCR的EPD内容和格式的要求；EPD之间可比性的要求；缩略词列表；引用文献；PCR的版本历史。如上述信息未包含在PCR中，则应在PCR中给出说明，并在PCR评审时获得批准。',
							img:require('@/assets/img/index/PCR_2x.png'),
							tips:'资料下载:',
							dwon_CN:'Download (CN)',
							dwon_EN:'Download (EN)',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
					]
				},
				{
					id:'4',
					name:'专家库',
					dec:'专家库介绍',
					children:[
						{
							id:'1',
							title:'钟掘',
							content:'钟掘（女）（1936.09.01- ）。机械工程专家。出生于江西省南昌市，原籍河北省献县。1960年毕业于北京科技大学。中南大学教授。     长期从事机械与制造工程的教学与科研。在轧制、锻、挤等金属塑性加工原理、工艺与装备的科学与工程研究中，注重探索大型复杂结构件材料流变的多尺度结构演变规律，研究材料与构件成形成性协同制造中的能量传递与转化规律，以获得高品质构件；进行系统动力学、复杂系统耦合与解耦设计理论、系统建模与仿真、系统辨识与故障诊断、残余应力与失效分析，塑性加工摩擦与润滑、新型材料制备机械研制等工作。其中较重要的是轧机驱动理论、高速轧机振动理论、冶金机械强度设计、现代高效材料制备技术与装备集成方面所取得的研究成果，发明了铝及铝合金的电磁铸轧技术与装备、在3万T模锻水压机功能升级、特宽铝板轧制线改扩建等多项材料加工生产的重大装备建设工程应用中取得实效。快速铸轧技术与装备，多次获得国家及省部级奖励，“变相驱动理论与技术开发”获1985年国家科技进步奖一等奖，“双机架铝热轧新技术开发”获1995年国家科技进步奖二等奖，“高性能特薄优质铝板”获1996年国家科技进步奖二等奖，“铝合金电磁铸轧技术与装备”获2002年国家技术发明二等奖，“铝资源高效利用与高性能铝材制造”获2007年国家科技进步一等奖。参加国家中长期科技发展规划战略研究，提出“极端制造”的概念与内涵，已被列入国家中长期科技发展规划。发表学术论文200余篇，专著4本。2002年获何梁何利科学技术奖。2000年被选为全国先进工作者。     1995年当选为中国工程院院士。',
							img:'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221111003_15386.jpg',
							tips:'',
							dwon_CN:'',
							dwon_EN:'',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
						{
							id:'2',
							title:'何季麟',
							content:'何季麟（1945.9.1），冶金与材料工程专家。生于河南省开封市，原籍河南开封。1969年毕业于北京钢铁学院。现任中色西北稀有金属材料研究院名誉院长。曾任宁夏有色金属集团公司总工程师，中国有色金属学会副理事长。获冶金工程学士学位。     何季麟同志长期从事有色、稀有金属冶炼与加工理论和工程化技术的研究开发工作。在稀有金属钽、铌、铍新材料领域取得了多项研究成果。研究开创了具有自主知识产权的钽铌金属冶炼、加工工艺、技术与方法并实现了工程化应用。主持并指导了特种铜合金、镁及镁合金、钛合金加工、钽电解电容器、电池材料、金属陶瓷靶材等多项新材料技术研究，在该领域主持实施了7项国家重点技改工程。     何季麟同志获授权专利9项，发表论文40余篇。获国家专利优秀奖1项。2007年“RTO金属包埋切片微米、纳米表征法”获“国家技术发明二等奖（R-03）”；2012年“超小型化钽电解电容器用关键材料生产技术与应用”获“国家科学技术进步二等奖（R-01）”；获省部级科技进步一等奖4项。荣获宁夏“科技明星”、“科学技术功勋奖”和“塞上英才”等奖励。1995年获全国劳动模范。     2001年当选为中国工程院院士。',
							img:'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221109031_80378.jpg',
							tips:'',
							dwon_CN:'',
							dwon_EN:'',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
						{
							id:'3',
							title:'孙传尧',
							content:'孙传尧，原籍山东，1944年12月13日生于黑龙江省饶河县，佳木斯市人，男，汉族，矿物加工工程专家，俄罗斯圣.彼得堡工程科学院院士，全国劳动模范，中共党员。1968年毕业于东北工学院（现东北大学）有色冶金系选矿专业，1981年北京矿冶研究总院选矿专业研究生毕业，获工学硕士学位。曾在新疆可可托海矿务局从事稀有金属锂铍鉭鈮选矿工作，任选矿厂副厂长。曾任北京矿冶研究总院院长，现任矿物加工科学与技术国家重点实验室主任。兼任中国矿业联合会选矿委员会主任、中国有色金属学会选矿学术委员会主任。     长期从事矿物加工及复杂多金属矿产资源综合利用的研究与设计工作，有丰富的选矿厂生产实践经验。在锂铍鉭鈮、铅锌、铜镍、钨铋钼，铁及黄金领域承担了多项科研任务，曾获国家科技进步二等奖4项，全国科学大会奖1项，省部级奖9项，获光华工程科技奖和有色金属科技进步特别贡献奖。发表学术论文150余篇。在理论研究中，与合作者共同开拓“矿物浮选的晶体化学原理”的学术方向，撰写出版学术专著《硅酸盐矿物浮选原理》。主编《选矿工程师手册》等大型专业书6部。培养博士研究生45人。近年来，提出“开发与矿物资源可选性相和谐的精细工艺技术（和谐选矿）和基因矿物加工工程（基因选矿）的学术观点。     2003年当选为中国工程院院士。',
							img:'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221107038_43575.jpg',
							tips:'',
							dwon_CN:'',
							dwon_EN:'',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
						{
							id:'4',
							title:'邱冠周',
							content:'邱冠周（1949.2.2- ）矿物工程学家。广东省梅州市人。1987年9月毕业于中南工业大学矿物加工工程专业，获博士学位。曾任中南工业大学副校长、中南大学副校长，现任中南大学教授、博士生导师。长期致力于我国低品位、复杂难处理金属矿产资源加工利用研究，在细粒及硫化矿物浮选分离和铁矿直接还原等方面取得显著成绩，特别是在低品位硫化矿的生物冶金方面做出突出贡献，被授予国家有突出贡献科技专家。发表了97篇科技论文和5部专著，先后获得国家技术发明二等奖2项，国家科技进步二等奖1项，国家科技进步一等奖1项，中国高等学校十大科技进展2项；2003年担任国家自然科学基金创新群体学术带头人，2004年、2009年连续两次担任生物冶金领域国家973计划项目首席科学家，担任2011年第19届国际生物冶金大会主席，并被推选为国际生物冶金学会副会长。     2011年当选中国工程院院士。',
							img:'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221106020_50416.jpg',
							tips:'',
							dwon_CN:'',
							dwon_EN:'',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
						{
							id:'5',
							title:'段宁',
							content:'段宁（1949.07.20- ）清洁生产专家。四川省成都市人。1975年毕业于同济大学给排水及暖通工程系，1981年获清华大学环境工程系硕士学位，1988年获美国德克萨斯州立大学奥斯汀分校土木工程系博士学位。现任中国环境科学研究院重金属清洁生产工程技术中心主任，曾任中国环境科学研究院副院长、环境保护部清洁生产中心主任。中国生态经济学会工业生态经济与技术专业委员会副理事长，中国工业节能与清洁生产协会副会长。     2011年当选为中国工程院院士。',
							img:'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221102053_82176.jpg',
							tips:'',
							dwon_CN:'',
							dwon_EN:'',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
						{
							id:'6',
							title:'蔡美峰',
							content:' 蔡美峰（1943.5.18- ）岩石力学与采矿工程专家。江苏省如东县人。1967年毕业于上海交通大学，1990年获新南威尔士大学采矿岩石力学博士学位。曾任北京科技大学土木与环境工程学院院长、国际岩石力学学会教育委员会主席，现任北京科技大学教授、国务院学位委员会矿业工程学科评议组召集人。     我国矿山地应力测量的主要开拓者之一，首次开发出我国具有自主知识产权的地应力测量技术，提出了以地应力为基础的采矿设计优化的技术体系、安全高效开采技术和矿山动力灾害预测与防控技术。曾获国家科技进步二等奖3项，三等奖1项，国家技术发明三等奖1项，已出版学术专著4部、发表学术论文150余篇，培养博士后20多名、博士90多名，硕士50多名，主编“十五”国家级规划教材1部，获国家级教学成果二等奖1项。     2013年当选中国工程院院士。',
							img:'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221047032_63709.jpg',
							tips:'',
							dwon_CN:'',
							dwon_EN:'',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
						{
							id:'7',
							title:'桂卫华',
							content:' 桂卫华，1950年8月7日出生于武汉，男，汉族，湖北省武汉市人，自动控制专家。中共党员。1975年毕业于中南矿冶学院工业企业电气化及自动化专业，1981年获得中南矿冶学院工业自动化专业硕士学位，1986年赴德国Duisburg大学自动控制专业做访问学者两年，曾任中南大学信息科学与工程学院院长，现任中南大学控制工程研究所所长、中国有色金属学会副理事长、中国自动化学会副理事长、湖南省自动化学会名誉理事长。     长期致力于流程工业生产过程控制理论、技术和工程应用的研究，围绕流程工业企业信息化和智能制造的技术问题，创建了以智能集成为核心的复杂有色冶金过程建模、控制与优化的理论与方法。成果主要应用在有色金属行业的多家大型企业，获得显著的经济效益和社会效益，为我国流程工业的快速发展、特别是自动化技术的提升和自主创新作出了重要贡献。其研究成果获国家科技进步二等奖3项，省部级科技奖励13项；获“何梁何利基金科学与技术进步奖”、“湖南光召科技奖”、“中国有色金属工业优秀科技工作者”、“中国过程控制技术贡献奖”、“杨嘉墀科技奖”等荣誉称号；出版专著5部等。执教三十余年，获得“全国优秀科技工作者”、“全国优秀教师”荣誉称号。     作为学术带头人，带领科研团队于2013年成为国家自然科学基金创新研究群体，2016年创新群体以整体优秀结题并获得国家自然科学基金委滚动支持。     2013年当选为中国工程院院士。',
							img:'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221046004_48353.jpg',
							tips:'',
							dwon_CN:'',
							dwon_EN:'',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
						{
							id:'8',
							title:'丁文江',
							content:'丁文江（1953.3.28- ）轻合金研究专家。生于上海市，原籍浙江绍兴。1981年毕业于上海交通大学铸造专业。现任轻合金精密成型国家工程研究中心主任。曾任上海交通大学副校长、上海市科委副主任。在国际上担任或曾担任：世界轻合金联盟轮值主席，中挪（中国和挪威）轻合金研究中心中方主席；日本九州大学外部评价委员；澳大利亚莫纳什大学顾问；美国通用—交大先进材料制造联合实验室主任。     长期从事先进镁合金材料及其精密成形研究，把镁与稀土相结合，开展系统研究，形成中国特色，迄今为止，在镁研究领域发表SCI论文308篇（其中3篇入选近10年ESI高引用论文），累计他引2469次，拥有发明专利114项，作为第一获奖人，2003年获国家科技进步二等奖，2006年获国家技术发明奖二等奖、2007年获上海市技术发明一等奖；创建了国家工程中心，凝聚三百余人的研发队伍，实现了基础研究，应用开发，工程化和技术转移的良性互动。全国国家工程研究中心二次评优并获国家工程中心20年重大成就奖。2010年获全国优秀科技工作者称号。     2013年当选为中国工程院院士。',
							img:'http://www.cnitdc.com/pub/grzxsy/hyzj/202104/20210422/jpg_202104221040023_91994.jpg',
							tips:'',
							dwon_CN:'',
							dwon_EN:'',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
					]
				},
				{
					id:'5',
					name:'项目库',
					dec:'专家库介绍',
					children:[{
								id:'1',
								title:'中国有色金属行业EPD平台环境绩效指标默认清单介绍',
								content:'附件是有色行业EPD平台EPD中环境绩效指标默认清单(以下简称默认清单）以及相应的评价方法介绍。如果某些环境绩效指标在 PCR 开发过程中已经证明是合理的，则 PCR 的要求或建议的环境绩效指标可能与默认清单所列的不一致。默认清单会根据 LCA 方法和标准的发展不断更新，以确保 EPD 的稳定性。在需要更新默认清单的情况下，默认清单的被替代版本至少应有90天的过渡期，在过渡期内，被替代版本与新版本同时有效。',
								img:require('@/assets/img/index/EPD_2x.png'),
								tips:'Download Information:',
								dwon_CN:'Download (CN)',
								dwon_EN:'Download (EN)',
								dwon_url_CN:'',
								dwon_url_EN:''
							},
							{
								id:'2',
								title:'中国有色金属行业EPD 平台和欧标 EN15804 对比分析',
								content:' 附件是中国有色金属行业EPD平台EPD中环境绩效指标默认清单(以下简称默认清单）以及相应的评价方法介绍。如果某些环境绩效指标在 PCR 开发过程中已经证明是合理的，则 PCR 的要求或建议的环境绩效指标可能与默认清单所列的不一致。默认清单会根据 LCA 方法和标准的发展不断更新，以确保 EPD 的稳定性。在需要更新默认清单的情况下，默认清单的被替代版本至少应有90天的过渡期，在过渡期内，被替代版本与新版本同时有效。',
								img:require('@/assets/img/index/EPD_2x.png'),
								tips:'资料下载:',
								dwon_CN:'Download (CN)',
								dwon_EN:'Download (EN)',
								dwon_url_CN:'',
								dwon_url_EN:''
							},
						]
					},
				{
					id:'6',
					name:'EPD/CFP Tools',
					dec:'EPD/CFP Tools介绍',
					children:[
						{
							id:'1',
							title:'低碳技术专家库系统',
							content:'低碳技术专家库系统是中国有色行业EPD平台集成的应用服务系统，可支持有色金属行业企业及产业链相关企业在线查询产品相关的低碳技术专家，有针对性的解决低碳技术难题，更多信息请登录系统后查看。',
							img:require('@/assets/img/index/GPI_2x.png'),
							tips:'低碳技术专家库系统入口：',
							dwon_CN:'进入',
							dwon_EN:'',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
						{
							id:'2',
							title:'低碳技术项目库',
							content:' 低碳技术项目库系统是中国有色行业EPD平台集成的应用服务系统，可支持有色金属行业企业及产业链相关企业在线查询产品相关的低碳技术项目，查询成功低碳技术案例，挖掘低碳技术，更多信息请登录系统后查看。',
							img:require('@/assets/img/index/GPI_2x.png'),
							tips:'低碳技术项目库入口：',
							dwon_CN:'进入',
							dwon_EN:'',
							dwon_url_CN:'',
							dwon_url_EN:''
						},
					]
				}
			]
		},
		service:{
			banner: [{
				tips:'Introduction of Services',
				title:'Introduction of Services content',
				content:'',
				img: require('@/assets/img/index/GPI_2x.png'),
				url: require('@/assets/img/index/banner01.png')
			}],
			serviceData
		},
		connect:{
			banner: [{
				tips:'Contact us',
				title:'Contact',
				content:'',
				img: require('@/assets/img/index/GPI_2x.png'),
				url: require('@/assets/img/index/banner01.png'),
				adress:'Contact Address: beijing',
				call:'Customer service Hotline: 0871-43255632',
				email:'Email Address: epd_cnia@sina.com'
			}],
			
		},
		about:{
			banner: [{
				tips:'Programme introduction',
				title:'Contact',
				content:'',
				img: require('@/assets/img/index/GPI_2x.png'),
				url: require('@/assets/img/index/banner01.png'),
				adress:'Contact Address: beijing',
				call:'Customer service Hotline: 0871-43255632',
				email:'Email Address: epd_cnia@sina.com'
			}],		
		},
		feedback:{
			banner: [{
				tips:'Feedback',
				title:'Feedback',
				content:'',
				img: require('@/assets/img/index/GPI_2x.png'),
				url: require('@/assets/img/index/banner01.png'),
				adress:'Contact Address: beijing',
				call:'Customer service Hotline: 0871-43255632',
				email:'Email Address: epd_cnia@sina.com'
			}],	
			form:{
				corporate:'Corporate',
				name:'Name',
				mailbox:'Mailbox',
				phone:'Phone',
				feedback:'Feedback',
				submit_btn:'Submit'
			}
		},
		sigin:{
			banner: [{
				tips:'Registration Information',
				title:'Registration Information',
				content:'',
				img: require('@/assets/img/index/GPI_2x.png'),
				url: require('@/assets/img/index/banner01.png'),
			}],	
			form:{
				corporate:'Enterprise Name',
				name:'Name',
				type:'Industry type',
				company:'Organizational form of the company',
				phone:'Phone number / Mailbox',
				code:'Verification Code',
				submit_btn:'Register',
				get_code:'Get the verification code'			
			},
			label:{
				corporate:'Enterprise Name',
				name:'Name',
				type:'Industry type',
				company:'Organizational form of the company',
				phone:'Phone number / Mailbox',
				code:'Verification Code',
				submit_btn:'Register',
				get_code:'Get the verification code'
			},
			placeholder:{
				corporate:'Please enter enterprise name',
				type:'Please select an industry type',
				company:'Please select a company organization form',
				phone:'Please enter your phone number/email address',
				code:'Please enter the verification code',
			},
			rules:{
				corporate:	[{ required: true, message:'Please enter the enterprise name', trigger: 'blur' },],
				type:	[{ required: true, message:'Please select an industry type', trigger: 'blur' },],	
				company:	[{ required: true, message:'Please select a company organization form', trigger: 'blur' },],
				phone:	[{ required: true, message:'Please enter your phone number/email address', trigger: 'blur' },],
				code:	[{ required: true, message:'Please enter the verification code', trigger: 'blur' },]
			}
		},
		seach:{
			// banner: [{
			// 	tips:'联系我们',
			// 	title:'公司简介',
			// 	content:'',
			// 	img: require('@/assets/img/index/GPI_2x.png'),
			// 	url: require('@/assets/img/index/banner01.png')
			// }],
			down_CN:'Download (CN)',
			down_EN:'Download (EN)',
			PCR:{
				seach_btn:'Seach',
				seach:'PCR Library',
				num:'个PCR文件',
				form:{
					name:'Company Name',
					PCR:'PCR',
					seach:'搜索',
					keywords:'Keywords'
				}
			},
			EPD:{
				seach_btn:'Seach',
				seach:'EPD/CFP Library',
				num:'个EPD/CFP文件',		
				form:{
					PCR:'PCR',
					seach:'Seach',
					keywords:'Keywords'
				}
			}
		},
		user:{
			banner: [{
				tips:'Account information',
				title:'Account information',
				content:'',
				img: require('@/assets/img/index/GPI_2x.png'),
				url: require('@/assets/img/index/banner01.png'),
			}],
			info:[
				{
					title:"Personal information",
					account:'Account Number',
					companyName:'Company Name',
					status:'Status'
				},
				{
					title:"Enterprise information",
					account:'Mailbox',
					companyName:'Company Name',
					status:'Condition'
				}
			],
			mine:[
				{
					title:"My EPD/CFP",
					img:require('@/assets/img/index/EPD_2x.png'),
					path: '/portal'
				},
				{
					title:"Verifying Independent Confirmation",
					img:require('@/assets/img/index/LCA_2x.png'),
					path: '/company'
				}
			],
			agreement:[		
				{
					title:"User registration agreement",
					img:require('@/assets/img/index/yhxy.png'),
					path: '/protocol'
				},
				{
					title:"Privacy policy",
					img:require('@/assets/img/index/yszc.png'),
					path: '/protocol'
				},
			],
			mine_title:'My information',
			agree_title:'Agreement'
		},
		company:{
			banner: [{
				tips:'Registration Information',
				title:'Registration Information',
				content:'',
				img: require('@/assets/img/index/GPI_2x.png'),
				url: require('@/assets/img/index/banner01.png'),
			}],	
			label:{
				code:'Unified social credit code',
				name:'Enterprise name',
				email:'Company email',
				adress:'Domicile',
				Legal:'Legal representative',
				person:'Contact person',
				information:'Contact information',
				postcode:'Postcode',
				business:'Upload business license',
				spread:'Spread the message',
				b_tips:'Uploads only support jpg and png formats, color scans orPhotocopy with red official seal, file size is not more than 5m',
				s_tips:'Upload only support jpg and png format, need to be stamped with official seal',
				down:'The file size does not exceed 5m Download the billinginformation templat',
				submit:'Submit',
				reset:'Reset'
			},
			placeholder:{
				code:'Please enter the unified social credit code',
				name:'Please enter the company name',
				email:"Please enter the company email address",
				adress:'Please enter your address',
				Legal:'Please enter legal representative',
				person:'Please enter contact person',
				information:'Please enter contact person',
				postcode:'Please enter postal code',
				business:'Please upload business license',
				spread:'Please spread the word for information',				
			},
			rules:{
				code:	[{ required: true, message:'Please enter the unified social credit code', trigger: 'blur' },],
				name:	[{ required: true, message:'Please enter the company name', trigger: 'blur' },],	
				email:	[{ required: true, message:'Please enter the company email address', trigger: 'blur' },],
				adress:	[{ required: true, message:'Please enter your address', trigger: 'blur' },],
				Legal:	[{ required: true, message:'Please enter legal representative', trigger: 'blur' },],
				person:	[{ required: true, message:'Please enter contact person', trigger: 'blur' },],
				information:	[{ required: true, message:'Please enter contact person', trigger: 'blur' },],
				postcode:	[{ required: true, message:'Please enter postal code', trigger: 'blur' },],
				business:	[{ required: true, message:'Please upload business license', trigger: 'blur' },],
				spread:	[{ required: true, message:'Please spread the word for information', trigger: 'blur' },],
			}
		},
		portal:{
			banner: [{
				tips:'My Portal',
				title:'My Portal',
				content:'',
				img: require('@/assets/img/index/GPI_2x.png'),
				url: require('@/assets/img/index/banner01.png'),
			}],	
			form:{
				corporate:'Enterprise Name',
				name:'Name',
				type:'Industry type',
				company:'Organizational form of the company',
				phone:'Phone number / Mailbox',
				code:'Verification Code',
				submit_btn:'Register',
				get_code:'Get the verification code'			
			},
			label:{
				corporate:'Enterprise Name',
				name:'Name',
				type:'Industry type',
				company:'Organizational form of the company',
				phone:'Phone number / Mailbox',
				code:'Verification Code',
				submit_btn:'Register',
				get_code:'Get the verification code'
			},
			placeholder:{
				corporate:'Please enter enterprise name',
				type:'Please select an industry type',
				company:'Please select a company organization form',
				phone:'Please enter your phone number/email address',
				code:'Please enter the verification code',
			},
			rules:{
				corporate:	[{ required: true, message:'Please enter the enterprise name', trigger: 'blur' },],
				type:	[{ required: true, message:'Please select an industry type', trigger: 'blur' },],	
				company:	[{ required: true, message:'Please select a company organization form', trigger: 'blur' },],
				phone:	[{ required: true, message:'Please enter your phone number/email address', trigger: 'blur' },],
				code:	[{ required: true, message:'Please enter the verification code', trigger: 'blur' },]
			}
		},
		myportal:{
			banner: [{
				tips:'My Portal',
				title:'My Portal',
				content:'',
				img: require('@/assets/img/index/GPI_2x.png'),
				url: require('@/assets/img/index/banner01.png'),
			}],
			label:{
				title:"Company Name",
				name:'Product Name',
				type:'Category',
				staus:'Progress',
				time:'Application Time',
			},
			mine:[
				{
					title:"公司名称",
					name:'产品名称',
					type:'所属类别',
					staus:'进度',
					time:'申请时间',
				},
				{
					title:"公司名称",
					name:'产品名称',
					type:'所属类别',
					staus:'进度',
					time:'申请时间',
				}
			],
			agreement:[
				{
					title:"Privacy policy",
					img:require('@/assets/img/index/EPD_2x.png'),
					path: '/portal'
				},
				{
					title:"User registration agreement",
					img:require('@/assets/img/index/EPD_2x.png'),
					path: '/portal'
				},
			],
			mine_title:'My Application',
			agree_title:'Published',
			down:"Download Report"			
		},
		protocol:{
			banner: [{
				tips:'Published',
				title:'Published',
				content:'',
				img: require('@/assets/img/index/GPI_2x.png'),
				url: require('@/assets/img/index/banner01.png'),
			}],	
			agreement:ENContent 
		}
}
